import KeenSlider from 'keen-slider';
import 'keen-slider/keen-slider.min.css';
import debounce from 'debounce';

// for the slider inside the prefooter block
document.addEventListener('DOMContentLoaded', function () {
  class ImgSlider extends HTMLElement {
    constructor() {
      super();
      // elements
      this.keenSliders = [];
      this.slider = this.querySelector('.keen-slider');
      this.next = this.querySelector('.js-img-slider__next');
      this.prev = this.querySelector('.js-img-slider__prev');
      this.pages = this.querySelectorAll('.js-img-slider__page');
    }
    connectedCallback() {
      // bindings
      // events
      this.onLoad();
    }
    disconnectedCallback() {
      this.keenSliders.forEach(slider => {
        if (slider.destroy) slider.destroy();
      });
    }
    onLoad() {
      this.initSliders();
    }
    initSliders() {
      if (!this.slider) return;
      this.initSlider(this.slider, 0);
    }
    initSlider(el, index) {
      if (!el) return;
      this.keenSliders[index] = new KeenSlider(el, {
        slides: {
          perView: 1,
          spacing: 0
        }
      }, [slider => {
        const changeNavigation = slider => {
          // arrows
          const details = slider.track.details;
          const current = details?.rel ?? 0;
          this.next?.removeAttribute('disabled');
          this.prev?.removeAttribute('disabled');
          if (current === 0) {
            this.prev?.setAttribute('disabled', 'disabled');
          }
          if (current >= details.maxIdx) {
            this.next?.setAttribute('disabled', 'disabled');
          }
          //pagination
          this.pages?.forEach(page => {
            page?.removeAttribute('aria-current');
          });
          this.pages?.[current]?.setAttribute('aria-current', 'true');
        };
        const addEvents = slider => {
          // arrows
          this.prev?.addEventListener('click', () => {
            slider.prev();
          });
          this.next?.addEventListener('click', () => {
            slider.next();
          });
          // pagination
          this.pages?.forEach((page, index) => {
            page.addEventListener('click', () => {
              slider.moveToIdx(index);
            });
          });
        };
        slider.on('created', () => {
          slider.container?.classList.add('is-ready');
          changeNavigation(slider);
          addEvents(slider);
        });
        slider.on('slideChanged', () => {
          changeNavigation(slider);
        });
      }]);
    }
  }
  customElements.define('img-slider', ImgSlider);
});